var React = require('react');

function DropDownArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.49581 4.35433e-09C5.84404 -2.60884e-08 6.20349 0.131055 6.48432 0.405083L10.7079 4.38443C11.0674 4.72994 11.1011 5.31374 10.7753 5.68308C10.4496 6.06434 9.9104 6.10008 9.55094 5.75457L5.49581 1.9301L1.44068 5.76648C1.08122 6.10008 0.530802 6.07625 0.216276 5.695C-0.0982495 5.31374 -0.0645496 4.72995 0.283675 4.39635L4.5073 0.393169C4.78813 0.131056 5.14759 3.47971e-08 5.49581 4.35433e-09Z","fill":"black"}));
}

DropDownArrow.defaultProps = {"width":"11","height":"6","viewBox":"0 0 11 6","fill":"none"};

module.exports = DropDownArrow;

DropDownArrow.default = DropDownArrow;
